"use strict";

define('rs/abstract.content.view',['require','exports','module','vertebrae','rs/helper'],function (require, exports, module) {
  var Vertebrae = require('vertebrae');
  var helper = require('rs/helper');
  var AbstractContentView = Vertebrae.View.extend({
    templates: {
      'content.footer': 'renderContentFooter'
    },
    events: {
      'click .rs-navigation-previous': 'handleNavigatePreviousClick',
      'keydown .rs-navigation-previous': 'handleNavigatePreviousKeydown'
    },
    initialize: function initialize() {
      this.listenTo(this, 'change:available', this.setupFixedHeader.proxy(this));
      this._watchedElements = [];
      this._super.apply(this, arguments);
    },
    hasStarted: function hasStarted() {
      return this.getDelegate().hasStarted();
    },
    handleNavigatePreviousKeydown: function handleNavigatePreviousKeydown(ev) {
      if (ev.keyCode === 13) {
        this.handleNavigatePreviousClick(ev);
      }
    },
    handleNavigatePreviousClick: function handleNavigatePreviousClick() {
      if (_.isFunction(this.getDelegate().requestNavigatePrevious)) {
        this.getDelegate().requestNavigatePrevious();
      }
    },
    showAnimate: function showAnimate(selector) {
      var el = this.$(selector);
      if (this.hasStarted()) {
        el.slideDown();
      } else {
        el.show();
      }
      return Promise.resolve(el.promise());
    },
    hideAnimate: function hideAnimate(selector) {
      var el = this.$(selector);
      if (this.hasStarted()) {
        el.slideUp();
      } else {
        el.hide();
      }
      return Promise.resolve(el.promise());
    },
    setupFixedHeader: function setupFixedHeader() {
      var that = this,
        unbind = null,
        handle = null,
        $el = this.$el,
        $window = $(window),
        delegate = this.getDelegate();
      unbind = function unbind() {
        $window.off('scroll', handle);
      };
      handle = function handle(ev) {
        if (that.$el) {
          that.contentDidScroll(ev);
        }
      };
      if (this.$el.hasClass('fixed-header')) {
        this.getContentHeader().css({});
      }
      if (Modernizr.touch) {
        return;
      }
      $(window).scroll(handle);
      if (delegate) {
        delegate.once('unload', unbind);
      }
    },
    contentDidScroll: function contentDidScroll() {
      if (this.getScrollElement().scrollTop() > 0) {
        this.$el.addClass('over');
      } else {
        this.$el.removeClass('over');
      }
    },
    processWatchedElements: function processWatchedElements() {
      var elements = this._watchedElements,
        that = this,
        scrollEl = this.getScrollElement(),
        e = null,
        offset = null,
        actualOffset = null,
        placeholder = null,
        height = null,
        contentHeader = this.getContentHeader(),
        headerHeight = contentHeader.outerHeight(),
        scrollTop = scrollEl.scrollTop(),
        borderBottom = parseInt(contentHeader.css('border-bottom-width')) || 0,
        paddingTop = parseInt(this.$el.css('padding-top')) || 0,
        top = headerHeight + paddingTop - borderBottom,
        len = elements ? elements.length : 0,
        current = null,
        nextBest = null,
        nextDiff = 0,
        previousBest = null,
        previousDiff = 0,
        currentTop = 0,
        currentTopActual = 0,
        doFix = null,
        undoFix = null,
        i = 0;
      doFix = function doFix(e, sub, add) {
        if (!e.fixed) {
          e.fixed = true;
          placeholder = $('<div/>');
          placeholder.css({
            height: e.height
          });
          e.$el.css({
            top: top
          });
          e.$el.addClass('content-scroll-item');
          e.$el.after(placeholder);
          e.placeholder = placeholder;
          that._currentFixed = e;
        }
      };
      undoFix = function undoFix(e) {
        if (e.fixed) {
          that._currentFixed = null;
          e.fixed = false;
          e.$el.attr('style', '').removeClass('content-scroll-item');
          if (e.placeholder) {
            e.placeholder.remove();
          }
        }
      };
      for (i = 0; i < len; ++i) {
        e = elements[i];
        if (!e.$el.is(':visible')) {
          undoFix(e);
          continue;
        }
        offset = e.fixed ? e.placeholder.offset() : e.$el.offset();
        offset.top -= scrollTop;
        actualOffset = e.$el.offset();
        if (offset.top < top) {
          if (!current || currentTop < offset.top) {
            current = e;
            currentTop = offset.top;
            currentTopActual = actualOffset.top;
          } else {
            if (!previousBest || previousBest.top < offset.top) {
              previousBest = {
                e: e,
                top: actualOffset.top
              };
            }
            undoFix(e);
          }
        } else {
          undoFix(e);
          if (!nextBest || nextBest.top > offset.top) {
            nextBest = {
              e: e,
              top: actualOffset.top
            };
          }
        }
      }
      if (current) {
        if (nextBest && nextBest.e != current) {
          nextDiff = nextBest.top - currentTopActual;
        }
        if (previousBest) {
          previousDiff = currentTopActual - previousBest.top;
        }
        if (previousDiff && previousDiff < current.height) {
          doFix(current, 0, current.height - previousDiff);
        } else if (nextDiff && nextDiff < current.height) {
          doFix(current, current.height - nextDiff);
        } else {
          doFix(current);
        }
      }
    },
    scrollToElement: function scrollToElement(el, animate) {
      var myOffset = this.$el.offset(),
        elOffset = el.offset(),
        scrollTop = elOffset.top - myOffset.top - 150;
      if (animate) {
        $(document.body).animate({
          scrollTop: scrollTop
        });
      } else {
        $(document.body).scrollTop(scrollTop);
      }
    },
    getScrollElement: function getScrollElement() {
      return $(window);
    },
    _setupTableViewScroll: function _setupTableViewScroll(view) {
      var header = view.getHeaderContainer();
      if (!header || !header.length) {
        return;
      }
      if (Modernizr.touch) {
        return;
      }
      this._watchedElements.push({
        view: view,
        $el: header,
        width: header.outerWidth(true),
        height: header.outerHeight(true)
      });
    },
    _removeWatchedTable: function _removeWatchedTable(view) {
      var len = this._watchedElements ? this._watchedElements.length : 0,
        i = 0,
        e = null;
      for (i = 0; i < len; ++i) {
        e = this._watchedElements[i];
        if (e.view === view) {
          return this._watchedElements.splice(i, 1)[0];
        }
      }
    },
    getContentHeader: function getContentHeader() {
      return this.$('.content-header');
    },
    getContentFooter: function getContentFooter() {
      return this.$('.content-footer');
    },
    getContentBody: function getContentBody() {
      return this.$('.content-body');
    },
    renderFooter: function renderFooter() {
      this.$el.append(this.renderContentFooter());
      this.getContentFooter().addClass('page-width border-top');
    },
    refreshContentSizing: function refreshContentSizing() {
      return;
      var header = this.getContentHeader(),
        footer = this.getContentFooter(),
        height = header.outerHeight(true),
        margin = 0,
        el = this.$('> .content-page-width');
      margin = parseInt(el.css('margin-bottom'));
      if (!el.length) {
        el = this.$el;
        if (header.length) {
          height += header.offset().top;
        }
      } else {
        el.css('min-height', window.innerHeight - header.offset().top - footer.outerHeight() - margin);
      }
      if (this.$el.hasClass('fixed-header') && !Modernizr.touch) {
        el.css('padding-top', height);
      }
    },
    unload: function unload() {
      this.$el.css('padding-top', '');
      this._super.apply(this, arguments);
    },
    resize: function resize() {}
  });
  module.exports = AbstractContentView;
});

